import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ExhibitorPageActions from '@planone/bau365/data-access-fair-data';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import { of, switchMap } from 'rxjs';

@Injectable()
export class ShowAllEffects {
  showAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExhibitorPageActions.showAllToJumpToSearch),
      switchMap((action) =>
        of(
          FeatureTrackingGoogleAnalytics.push({
            event: 'click_show_all_to_jump_to_search',
            context: action.context,
            page_type: 'exhibitor-details',
            exhibitor_id: action.exhibitor_id,
            exhibitor_name: action.exhibitor_name,
            entity_type: action.entity_type,
          })
        )
      )
    )
  );

  constructor(private readonly actions$: Actions) {}
}
